import React from 'react'
import { Input } from 'antd'
import i18n from '../../../../lib/i18n'
import { splitVariants } from '../../../QuestionsLearning/questionTypes'
import { isCorrect } from '../../grading'
import styles from './answers.module.scss'

// type1: free text answer
function AnswerText({ question, draft, onChange, checked, onSubmit }) {
  const correct = checked && isCorrect(question, draft)
  return (
    <div className={styles.stack}>
      <Input
        size="large"
        className={styles.textInput}
        value={draft}
        disabled={checked}
        status={checked && !correct ? 'error' : undefined}
        placeholder={i18n('qv_type_answer')}
        onChange={(e) => onChange(e.target.value)}
        onPressEnter={onSubmit}
      />
      {checked && !correct && (
        <div className={styles.correctHint}>
          {i18n('qv_correct_answer')}: <b>{splitVariants(question.answers).join(' / ')}</b>
        </div>
      )}
    </div>
  )
}

export default AnswerText
